class ArtistShowcase {
  constructor(container) {
    this.container = container;
    this.quotes = this.container.querySelectorAll('[data-quote-index]');
    this.thumbnails = Array.from(this.container.querySelectorAll('[data-thumbnail-index]'));
    this.grids = this.container.querySelectorAll('[data-grid-index]');
    this.prevButton = this.container.querySelector('.prev-arrow');
    this.nextButton = this.container.querySelector('.next-arrow');
    this.artistCards = this.container.querySelectorAll('.artist-card');
    this.closeBioButtons = this.container.querySelectorAll('.close-bio-btn');
    
    this.currentGridIndex = 0; 
    this.currentArtistIndex = 0; 
    this.totalArtists = this.thumbnails.length;
    this.itemsPerSlide = 4; 
    this.totalGrids = this.grids.length; 

    if (this.totalArtists === 0) return;

    this.init();
  }

  init() {
    this.prevButton.addEventListener('click', () => this.changeGrid('prev'));
    this.nextButton.addEventListener('click', () => this.changeGrid('next'));

    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        const artistIndex = parseInt(e.currentTarget.dataset.thumbnailIndex);
        this.selectArtist(artistIndex);
      });
    });
    
    this.artistCards.forEach(card => {
        card.addEventListener('click', (e) => {
           if (e.target.closest('.close-bio-btn') || e.target.closest('.artist-btn')) return;
           
           const artistIndex = parseInt(card.dataset.artistIndex);
           this.selectArtist(artistIndex);
           this.showBio(card);
        });
    });

    this.closeBioButtons.forEach(button => {
        button.addEventListener('click', (e) => {
           e.stopPropagation();
           const card = button.closest('.artist-card');
           this.hideBio(card);
        });
    });

    this.updateDisplay();
  }

  changeGrid(direction) {
    if (direction === 'next') {
      this.currentGridIndex = (this.currentGridIndex + 1) % this.totalGrids;
    } else {
      this.currentGridIndex = (this.currentGridIndex - 1 + this.totalGrids) % this.totalGrids;
    }
    
    this.currentArtistIndex = this.currentGridIndex * this.itemsPerSlide;
    this.updateDisplay();
  }

  selectArtist(artistIndex) {
    if (artistIndex === this.currentArtistIndex) return;
    
    this.currentArtistIndex = artistIndex;
    this.currentGridIndex = Math.floor(artistIndex / this.itemsPerSlide);
    this.updateDisplay();
  }

  updateDisplay() {
    this.grids.forEach(grid => grid.classList.remove('is-active'));
    const activeGrid = this.container.querySelector(`[data-grid-index="${this.currentGridIndex}"]`);
    if (activeGrid) {
      activeGrid.classList.add('is-active');
    }

    const startIndex = this.currentGridIndex * this.itemsPerSlide;
    const endIndex = Math.min(startIndex + this.itemsPerSlide, this.totalArtists);
    
    this.thumbnails.forEach((thumb, index) => {
      // 优化：仅在必要时操作 DOM class
      const shouldBeVisible = index >= startIndex && index < endIndex;
      if (thumb.classList.contains('is-visible') !== shouldBeVisible) {
         thumb.classList.toggle('is-visible', shouldBeVisible);
      }
      
      const shouldBeActive = index === this.currentArtistIndex;
      if (thumb.classList.contains('is-active') !== shouldBeActive) {
         thumb.classList.toggle('is-active', shouldBeActive);
      }
    });

    this.quotes.forEach(quote => quote.classList.remove('is-active'));
    const activeQuote = this.container.querySelector(`[data-quote-index="${this.currentArtistIndex}"]`);
    if (activeQuote) {
      activeQuote.classList.add('is-active');
    }

    // 隐藏所有 Bio，除非有特殊逻辑保持，这里保持原有逻辑
    this.artistCards.forEach(card => this.hideBio(card));
    
    this.highlightActiveCard();
  }

  highlightActiveCard() {
    this.artistCards.forEach(card => {
      const cardIndex = parseInt(card.dataset.artistIndex);
      // JS 性能优化：不再直接修改 element.style.boxShadow/transform
      // 而是切换 class，让 CSS 处理渲染和过渡，减少 JS 线程负担
      if (cardIndex === this.currentArtistIndex) {
        card.classList.add('is-highlighted');
      } else {
        card.classList.remove('is-highlighted');
      }
    });
  }
  
  showBio(card) {
    card.classList.add('bio-is-visible');
  }

  hideBio(card) {
    card.classList.remove('bio-is-visible');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.artist-showcase-section');
  sections.forEach(section => {
    new ArtistShowcase(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.artist-showcase-section');
  if (section) {
    new ArtistShowcase(section);
  }
});